import Navigation from './navigation/navigation.vue'
import BookSidebar from './sidebar/BookSidebar.vue'
import PerfilSidebar from './sidebar/PerfilSidebar.vue'
import ArrowButton from './core/ArrowButton.vue'
import ArrowButtonOutline from './core/ArrowButtonOutline.vue'
import AppModal from './core/ArrowButtonOutline.vue'

const components = [
    { key: 'Navigation', component: Navigation },
    { key: 'BookSidebar', component: BookSidebar },
    { key: 'PerfilSidebar', component: PerfilSidebar },
    { key: 'ArrowButton', component: ArrowButton },
    { key: 'ArrowButtonOutline', component: ArrowButtonOutline },
    { key: 'AppModal', component: AppModal },
]

export default (vue: any) => {
    const prefix = 'X'
    components.forEach((component) => {
        vue.component(`${prefix}${component.key}`, component.component)
    })
}
